import { Component, Input } from '@angular/core';

export interface IDesignerInformationMessage {
  message: string;
  hyperlink?: {
    text: string,
    src: string,
    target?: string
  }
}

@Component({
  selector: 'app-designer-information',
  templateUrl: './designer-information.component.html',
  styleUrls: ['./designer-information.component.scss'],
  standalone: false
})
export class DesignerInformationComponent {

  @Input()
  informationMessages: IDesignerInformationMessage[];
}
